import styled from "styled-components"

export const Title = styled.h3`
  padding-bottom: 0.6rem;
  border-bottom: 5px solid #eee;
  font-family: "Abril", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 2.4rem;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: normal;
  color: ${({ theme }) => theme.colors.text.primary};
`
